import React, { useEffect, useState, useRef } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Drawer, Form, Input, Row, Select, Space } from 'antd';
import { additem, info, moditem, svc_filters, restypes, methods } from './Util'
import { Modal } from 'antd';

const { Option } = Select;

const authors = [
    {'text':"박용관", 'value':'박용관'},
    {'text':"백제원", 'value':'백제원'},
    {'text':"성현진", 'value':'성현진'},
    {'text':"정희정", 'value':'정희정'}
];

const RegDrawer = (props) => {

    const [form] = Form.useForm();

    const [apiname, setApiName] = useState(null);
    const [uri, setUri] = useState(null);
    const [header, setHeader] = useState(null);
    const [param, setParam] = useState(null);
    const [body, setBody] = useState(null);    
    const [owner, setOwner] = useState("백제원");
    const [svcmodel, setSvcModel] = useState(1);
    const [method, setMethod] = useState("0");
    const [restype, setResType] = useState(1);
    const [content, setContent] = useState(null);
    const [prefer, setPrefer] = useState(null);
    const [myid, setId] = useState(null);

    const init = () => {
        setApiName(null);
        setUri(null);
    }

    useEffect(() => {
        if (props.init) {
            form.setFieldsValue({
                apiname: null,
                uri: null,
                owner: null,
                svcmodel: null,
                restype: null,
                content: null,
                method: null,
                header: '',
                param: '',
                body: '',                            
                prefer: ''
            })
            setId(null);
        }
        else {
            if (props.data) {
                var restype = "";
                var svcmodel = "";
                var method = "";
                /*
                 console.log(props.data.z_apiname,
                    props.data.z_owner,
                    props.data.z_svcmodel,
                    props.data.z_restype,
                    );
                    */

                /*
            if (props.data.z_svcmodel === 1) {
                svcmodel = "1";
            } else if (props.data.z_svcmodel === 2) {
                svcmodel = "2";
            } else if (props.data.z_svcmodel === 3) {
                svcmodel = "3";
            }
            */
                //svcmodel = (props.data.z_svcmodel).toString();
                //restype = (props.data.z_restype).toString();
                //method = (props.data.z_method).toString();
                /*
                if (props.data.z_restype === 0) {
                    restype = "0";
                } else if (props.data.z_restype === 1) {
                    restype = "1";
                } else if (props.data.z_restype === 2) {
                    restype = "2";
                }
                */

                setId(props.data.z_myid);
                form.setFieldsValue({
                    apiname: props.data.z_apiname,
                    uri: props.data.z_uri,
                    owner: props.data.z_owner,
                    svcmodel: svcmodel,
                    restype: restype,
                    method: method,
                    header: props.data.z_header,
                    param: props.data.z_param,
                    body: props.data.z_body,
                    prefer: props.data.z_prefer,
                    content: props.data.z_content                    
                })
            }
        }
    }, [props.init, props.data])

    const onSubmit = (e) => {
        // page refresh를 막아준다
        e.preventDefault();
        //console.log("onSubmit click!!!!!!");
        var apiname = form.getFieldValue("apiname");
        var uri = form.getFieldValue("uri");
        var owner = form.getFieldValue("owner");
        var svcmodel = form.getFieldValue("svcmodel");
        var restype = form.getFieldValue("restype");
        var method = form.getFieldValue("method");
        var content = form.getFieldValue("content");
        var header = form.getFieldValue("header");
        var param = form.getFieldValue("param");
        var body = form.getFieldValue("body");
        var prefer = form.getFieldValue("prefer");

        //console.log(uri, owner, svcmodel, restype);
        if (uri && uri.length > 0) {
            if (uri.includes('http:') === true || uri.includes('https:') === true) {
                info('도메인을 제외한 uri를 입력하세요')
                return;
            }
        }

        if (apiname === null || owner === null || svcmodel === null || restype === null || content === null || method === null) {
            console.log("must inpuat all");
            return;
        }
        if (myid > 0) {
            moditem(myid, apiname, uri, owner, svcmodel, restype, content, method, header, param, body, prefer, props.onClose);
        } else {
            additem(apiname, uri, owner, svcmodel, restype, content, method, header, param, body, prefer);
        }
    };


    function DrawCol(props) {
        return (
            <Form.Item
                name={props._name}
                label={props._label}
                rules={[
                    {
                        required: props._req,
                        message: props._msg,
                    },
                ]}
            >
                <Input className={props._name} placeholder={props._msg} onChange={props._onChange} />
            </Form.Item>
        );
    }

    function DrawCol_InputArea(props) {
        return (
            <Form.Item
                name={props._name}
                label={props._label}
                rules={[
                    {
                        required: props._req,
                        message: props._msg,
                    },
                ]}
            >
                <Input.TextArea rows={5} placeholder={props._msg} onChange={props._onChange} />
            </Form.Item>
        );
    }

    function DrawCol_Selector(props) {
        return (
            <Form.Item
                name={props._name}
                label={props._label}
                rules={[
                    {
                        required: props._req,
                        message: props._msg,
                    },
                ]}
            >
                <Select placeholder={props._msg} onChange={props._onChange}>
                    {props._list.map((item) => <Option value={item.value}>{item.text}</Option>)}
                </Select>
            </Form.Item>
        );
    }

    return (
        <Drawer
            title="crate new event"
            width={720}
            onClose={props.onClose}
            open={props.open}
            bodyStyle={{
                paddingBottom: 80,
            }}
            extra={
                <Space>
                    <Button onClick={props.onClose}>취소</Button>
                    <Button onClick={onSubmit} type="primary">
                        등록
                    </Button>
                </Space>
            }
        >
            <Form layout="vertical" form={form}>
                <Row gutter={16}>
                    <Col span={24}>
                        <DrawCol _req={true} _name='apiname' _label='행사 명' _msg='행사명을 입력해주세요' onChange={setApiName}></DrawCol>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <DrawCol_Selector _req={false} _name='svcmodel' _label='장소' _msg='장소를 선택해 주세요' _list={svc_filters} onChange={setSvcModel}></DrawCol_Selector>
                    </Col>
                 </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <DrawCol _req={false} _name='restype' _label='주소(직접입력)' _msg='장소가 없는 경우 직접 주소를 입력하세요' onChange={setResType}></DrawCol>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <DrawCol _req={false} _name='uri' _label='날짜' _msg='날짜를 선택하세요' onChange={setUri}></DrawCol>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <DrawCol _req={false} _name='uri' _label='장르' _msg='장르를 선택하세요' onChange={setUri}></DrawCol>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <DrawCol_InputArea _req={false} _name='body' _label='행사포스터' _msg='복사/붙여넣기 가능합니다' onChange={setBody}></DrawCol_InputArea>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
}

export default RegDrawer;

